import { Route, UrlMatchResult, UrlSegment } from '@angular/router';
import { WebsiteLayoutComponent } from './core/layouts/website/website.component';
import { NotFoundComponent } from './pages/notfound/notfound.component';
import { searchResultResolver } from './pages/search-result/guards/search-result.resolver';
import { urlValidatorGuard } from '@core/guards/url-validator.guard';
import { SearchResultComponent } from './pages/search-result/search-result.component';
import { internationalHotelsComponent } from './pages/international-hotels/international-hotels.component';

export const dataEcolodge = [
  'ویلا',
  'کلبه',
  'خانه‌-آپارتمان',
  'خانه‌-مسافر',
  'اقامتگاه-بومگردی',
  'ساحلی',
  'جنگلی',
];
export const appRoutes: Route[] = [
  {
    path: '',
    component: WebsiteLayoutComponent,
    children: [
      {
        path: 'notfound',
        component: NotFoundComponent,
      },
      {
        path: '',
        loadChildren: () =>
          import('./pages/home/home.module').then((m) => m.HomeModule),
      },
      {
        path: 'international-hotels',
        component: internationalHotelsComponent,
      },
      {
        matcher: (segments: UrlSegment[]): UrlMatchResult | null => {
          let isHotelTypeRoute = false;
          if (decodeURIComponent(segments[1]?.path) == 'خانه-مسافر') isHotelTypeRoute = true;
          if (decodeURIComponent(segments[1]?.path) == 'جنگلی') isHotelTypeRoute = true;
          if (decodeURIComponent(segments[1]?.path) == 'تیپ-جنگلی') isHotelTypeRoute = true;
          if (decodeURIComponent(segments[1]?.path) == 'ساحلی') isHotelTypeRoute = true;
          if (decodeURIComponent(segments[1]?.path) == 'تیپ-ساحلی') isHotelTypeRoute = true;
          if (decodeURIComponent(segments[1]?.path) == 'ویلا') isHotelTypeRoute = true;
          if (decodeURIComponent(segments[1]?.path) == 'کلبه') isHotelTypeRoute = true;
          if (decodeURIComponent(segments[1]?.path) == 'اقامتگاه-بومگردی') isHotelTypeRoute = true;
          if (decodeURIComponent(segments[1]?.path) == 'خانه') isHotelTypeRoute = true;
          if (
            segments.length > 1 &&
            segments[0]?.path.includes('ecolodge') &&
            isHotelTypeRoute &&
            segments[2]?.path.includes('map')
          ) {
            return {
              consumed: segments,
              posParams: {
                typeName: new UrlSegment(segments[1].path, {}),
              },
            };
          }
          return null;
        },
        loadComponent: () =>
          import('./shared/components/map/map.component').then((m) => m.MapComponent),
        data: { accommodation: 'ecolodge' },
        resolve: { data: searchResultResolver },
        runGuardsAndResolvers: 'always',
        canMatch: [urlValidatorGuard],
      },

      // ✅ برای سایر مسیرهای `/city-name/map` و `/country/city-name/map`
      {
        matcher: (segments: UrlSegment[]): UrlMatchResult | null => {
          if (segments.length >= 2 && segments[1].path === 'map') {
            // مسیرهایی مانند `/city-name/map`
            return {
              consumed: segments,
              posParams: {
                'city-name': new UrlSegment(segments[0].path, {}),
              },
            };
          } else if (segments.length >= 3 && segments[2].path === 'map') {
            // مسیرهایی مانند `/country/city-name/map`
            return {
              consumed: segments,
              posParams: {
                country: new UrlSegment(segments[0].path, {}),
                'city-name': new UrlSegment(segments[1].path, {}),
              },
            };
          }
          return null;
        },
        loadComponent: () =>
          import('./shared/components/map/map.component').then(
            (m) => m.MapComponent
          ),
        resolve: { data: searchResultResolver },
        runGuardsAndResolvers: 'always',
        canMatch: [urlValidatorGuard]
      },
      {
        matcher: (segments: UrlSegment[]): UrlMatchResult | null => {
          if (
            segments.length > 1 &&
            (segments[1].path.includes('-rec') || segments[1].path.includes('star'))
          ) {
            return {
              consumed: segments,
              posParams: {
                'city-name': new UrlSegment(segments[0].path, {}),
                pageGenerator: new UrlSegment(segments[1].path, {}),
              },
            };
          }
          return null;
        },
        loadChildren: () =>
          import('./pages/search-result/search-result.module').then((m) => m.SearchResultModule),
        canMatch: [urlValidatorGuard]
      },
      

      {
        matcher: (segments: UrlSegment[]): UrlMatchResult | null => {
          let isHotelTypeRoute = false;
          if (segments[1]?.path == 'خانه-مسافر') isHotelTypeRoute = true;
          if (segments[1]?.path == 'جنگلی') isHotelTypeRoute = true;
          if (segments[1]?.path == 'تیپ-جنگلی') isHotelTypeRoute = true;
          if (segments[1]?.path == 'ساحلی') isHotelTypeRoute = true;
          if (segments[1]?.path == 'تیپ-ساحلی') isHotelTypeRoute = true;
          if (segments[1]?.path == 'ویلا') isHotelTypeRoute = true;
          if (segments[1]?.path == 'کلبه') isHotelTypeRoute = true;
          if (segments[1]?.path == 'اقامتگاه-بومگردی') isHotelTypeRoute = true;
          if (segments[1]?.path == 'خانه') isHotelTypeRoute = true;
          if (segments.length > 1 && segments[0].path?.includes('ecolodge') && isHotelTypeRoute) {
            return {
              consumed: segments,
              posParams: {
                typeName: new UrlSegment(segments[1].path, {}),
              },
            };
          }
          return null;
        },
        data: { type: 'typeName', accommodation: 'ecolodge' },
        loadChildren: () =>
          import('./pages/search-result/search-result.module').then((m) => m.SearchResultModule),
        canMatch: [urlValidatorGuard]
      },
      {
        matcher: (segments: UrlSegment[]): UrlMatchResult | null => {
          if (segments.length === 2 && segments[0].path === 'ecolodge') {
            // مسیر `ecolodge/:city-name`
            return {
              consumed: segments,
              posParams: {
                ecolodge: new UrlSegment(segments[0].path, {}),
                'city-name': new UrlSegment(segments[1].path, {}),
              },
            };
          }
          return null;
        },
        data: { accommodation: 'ecolodge' },
        loadChildren: () =>
          import('./pages/search-result/search-result.module').then(
            (m) => m.SearchResultModule
          ),
        canMatch: [urlValidatorGuard]
      },
      {
        matcher: (segments: UrlSegment[]): UrlMatchResult | null => {
          if (segments.length === 3 && segments[0].path === 'ecolodge') {
            // مسیر `ecolodge/:city-name/:resident-name`
            return {
              consumed: segments,
              posParams: {
                ecolodge: new UrlSegment(segments[0].path, {}),
                'city-name': new UrlSegment(segments[1].path, {}),
                'resident-name': new UrlSegment(segments[2].path, {}),
              },
            };
          }
          return null;
        },
        data: { accommodation: 'ecolodge' },
        loadChildren: () =>
          import('./pages/accommodation-info/accommodation-info.module').then(
            (m) => m.AccommodationInfoModule
          ),
        canMatch: [urlValidatorGuard]
      },


      {
        matcher: (segments: UrlSegment[]): UrlMatchResult | null => {
          const hotelPattern = /^[a-zA-Z0-9-]+-hotels$/; // تشخیص مسیرهایی که با `-hotels` تمام می‌شوند

          if (segments.length === 2 && hotelPattern.test(segments[0].path)) {
            // مسیر `isfahan-hotels/:resident-name` یا `mashhad-hotels/:resident-name` باید به `AccommodationInfoModule` برود
            return {
              consumed: segments,
              posParams: {
                'city-name': new UrlSegment(segments[0].path, {}),
                'resident-name': new UrlSegment(segments[1].path, {}),
              },
            };
          }
          return null;
        },
        data: { accommodation: 'hotel' },
        loadChildren: () =>
          import('./pages/accommodation-info/accommodation-info.module').then(
            (m) => m.AccommodationInfoModule
          ),
        canMatch: [urlValidatorGuard]
      },
      {
        matcher: (segments: UrlSegment[]): UrlMatchResult | null => {
          const cityPattern = /^[a-zA-Z0-9-]+-hotels$/; 

          if (segments.length === 1 && cityPattern.test(segments[0].path)) {
            // مسیر `isfahan-hotels/` یا `mashhad-hotels/` باید به `SearchResultModule` برود
            return {
              consumed: segments,
              posParams: {
                'city-name': new UrlSegment(segments[0].path, {}),
              },
            };
          }
          return null;
        },
        loadChildren: () =>
          import('./pages/search-result/search-result.module').then(
            (m) => m.SearchResultModule
          ),
        canMatch: [urlValidatorGuard]
      },
    
      {
        matcher: (segments: UrlSegment[]): UrlMatchResult | null => {
          const cityPattern = /^[a-zA-Z0-9-]+-hotels$/; 

          if (segments.length === 1 && !cityPattern.test(segments[0].path)) {
            // .../turky
            return {
              consumed: segments,
              posParams: {
                country: new UrlSegment(segments[0].path, {}),
              },
            };
          }
          return null;
        },
        loadChildren: () =>
          import('./pages/search-result/search-result.module').then(
            (m) => m.SearchResultModule
          ),
        canMatch: [urlValidatorGuard]
      },
      
      {
        matcher: (segments: UrlSegment[]): UrlMatchResult | null => {
          if (segments.length === 2 && !segments[0].path.includes('-')) {
            // مسیر `turkey/istanbul` یا `iran/tehran` باید به `SearchResultModule` برود
            return {
              consumed: segments,
              posParams: {
                country: new UrlSegment(segments[0].path, {}),
                'city-name': new UrlSegment(segments[1].path, {}),
              },
            };
          }
          return null;
        },
        loadChildren: () =>
          import('./pages/search-result/search-result.module').then(
            (m) => m.SearchResultModule
          ),
        canMatch: [urlValidatorGuard]
      },
      // when url incules star and rec
      {
        matcher: (segments: UrlSegment[]): UrlMatchResult | null => {
          if (
            !segments[0].path.includes('-') &&
            segments.length > 1 &&
            (segments[2]?.path.includes('-rec') || segments[2]?.path.includes('star'))
          ) {
            return {
              consumed: segments,
              posParams: {
                country: new UrlSegment(segments[0].path, {}),
                'city-name': new UrlSegment(segments[1].path, {}),
                pageGenerator: new UrlSegment(segments[2].path, {}),
              },
            };
          }
          return null;
        },
        loadChildren: () =>
          import('./pages/search-result/search-result.module').then((m) => m.SearchResultModule),
        canMatch: [urlValidatorGuard]
      },


      {
        matcher: (segments: UrlSegment[]): UrlMatchResult | null => {
          if (segments.length === 3 && !segments[0].path.includes('-')) {
            // مسیر `turkey/istanbul/seminal` باید به `AccommodationInfoModule` برود
            return {
              consumed: segments,
              posParams: {
                country: new UrlSegment(segments[0].path, {}),
                'city-name': new UrlSegment(segments[1].path, {}),
                'resident-name': new UrlSegment(segments[2].path, {}),
              },
            };
          }
          return null;
        },
        data: { accommodation: 'hotel' },
        loadChildren: () =>
          import('./pages/accommodation-info/accommodation-info.module').then(
            (m) => m.AccommodationInfoModule
          ),
        canMatch: [urlValidatorGuard]
      },
      {
        path: 'ecolodge/search',
        data: { accommodation: 'ecolodge' },
        loadChildren: () =>
          import('./pages/search-result/search-result.module').then((m) => m.SearchResultModule),
        canMatch: [urlValidatorGuard]
      },
      {
        matcher: (segments: UrlSegment[]): UrlMatchResult | null => {
          if (
            segments.length > 1 &&
            segments[0].path.includes('-ecolodge') &&
            segments[1].path.includes('-rec')
          ) {
            return {
              consumed: segments,
              posParams: {
                'city-name': new UrlSegment(segments[1].path, {}),
                pageGenerator: new UrlSegment(segments[2].path, {}),
              },
            };
          }
          return null;
        },
        loadChildren: () =>
          import('./pages/search-result/search-result.module').then((m) => m.SearchResultModule),
        canMatch: [urlValidatorGuard]
      },
      {
        path: '**',
        component: NotFoundComponent,
        pathMatch: 'full',
      },
    ],
  },
];

